import React from 'react'
import Profile from './Profile'
const ProfilePage = () => {
  return (
    <div>
      <Profile />
    </div>
  )
}

export default ProfilePage
